import { BaseService } from "./BaseService";
import {
  ListMessageDeliveriesParams,
  MessageDelivery,
} from "@/types/message-delivery";

class MessageDeliveriesService extends BaseService {
  private basePath = "/hotels";

  list(
    hotelId: string,
    params: ListMessageDeliveriesParams,
  ): Promise<MessageDelivery[]> {
    return this.get<MessageDelivery[]>(
      `${this.basePath}/${hotelId}/message-deliveries`,
      params,
    );
  }
}

export const messageDeliveriesService = new MessageDeliveriesService();
